// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3eMFl","actionsCol":"EnrolledClinics_actionsCol__-0ODp"};